module.exports = __webpack_public_path__ + "static/media/watch_nav_watch_os.17fced49.svg";